<mg-btn
  variant="icon"
  iconSet="material"
  icon="more_horiz">
</mg-btn>
